// extracted by mini-css-extract-plugin
export default {"status":"DBNWGwPjPaI8sNgppgeVi","statusUnknown":"qtIQ1zNpCgKY2wlxErbnF"};